export const API_URL = process.env.API_URL
export const MEDIA_URL = process.env.MEDIA_URL
export const API_TEAMS = `${API_URL}/teams`
export const API_USERS = `${API_URL}/users`
export const API_LEXICONS = `${API_URL}/lexicons`
export const API_MY_PROJECTS = `${API_URL}/me/projects`
export const API_PROJECTS = `${API_URL}/projects`
export const API_ECP_PROJECTS = `${API_URL}/projects_ecp`
export const API_ME = `${API_URL}/me`